import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconArrowDiagonalDownLeftStyle0 = cosmosIconCss;

const CosmosIconArrowDiagonalDownLeft$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDiagonalDownLeft extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6c67c9ce2e6f0a3684c1deb3d004ea9f61e9c6d9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'aee2aeb844c3bdb494a24dfb33020e725a4ed960', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2595d591cbb4c979a59bf0cf505fdffb8c6d31e8', d: "M7.36 13.59V9.14a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .148.356.5.5 0 0 0 .356.149h6.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5H8.425l7.579-7.579a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0L7.36 13.59Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconArrowDiagonalDownLeftStyle0; }
}, [1, "cosmos-icon-arrow-diagonal-down-left", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-diagonal-down-left"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-diagonal-down-left":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDiagonalDownLeft$1);
            }
            break;
    } });
}

const CosmosIconArrowDiagonalDownLeft = CosmosIconArrowDiagonalDownLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDiagonalDownLeft, defineCustomElement };
